import axios from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { api } from 'services/api';
import { notificationContainer } from 'utils/notificationContainer';
import {
	TMassPostSaleJobOrdersRequest,
	TMassPostSaleJobOrdersResponse,
	TMassPostSaleJobsRequest,
	TMassPostSaleJobsResponse,
} from './types';
import {
	getMassPostSaleJobsRequest,
	getMassPostSaleJobsSuccess,
	getMassPostSaleJobsFailure,
	getMassPostSaleJobOrdersRequest,
	getMassPostSaleJobOrdersSuccess,
	getMassPostSaleJobOrdersFailure,
} from './reducer';

function* getMassPostSaleJobsWorker(action: PayloadAction<TMassPostSaleJobsRequest>) {
	try {
		const response: TMassPostSaleJobsResponse = yield call(
			api.massPostSaleJobs.getJobs,
			action.payload,
		);
		yield put(getMassPostSaleJobsSuccess(response));
	} catch (error) {
		yield put(getMassPostSaleJobsFailure());
		if (axios.isAxiosError(error)) {
			notificationContainer(
				String(error?.response?.data?.message ?? error?.response?.data ?? error ?? 'Error'),
				'error',
			);
		}
	}
}

function* getMassPostSaleJobOrdersWorker(action: PayloadAction<TMassPostSaleJobOrdersRequest>) {
	try {
		const response: TMassPostSaleJobOrdersResponse = yield call(
			api.massPostSaleJobs.getJobOrders,
			action.payload,
		);
		yield put(getMassPostSaleJobOrdersSuccess(response));
	} catch (error) {
		yield put(getMassPostSaleJobOrdersFailure());
		if (axios.isAxiosError(error)) {
			notificationContainer(
				String(error?.response?.data?.message ?? error?.response?.data ?? error ?? 'Error'),
				'error',
			);
		}
	}
}

export function* massPostSaleJobsSaga() {
	yield takeLatest(getMassPostSaleJobsRequest.type, getMassPostSaleJobsWorker);
	yield takeLatest(getMassPostSaleJobOrdersRequest.type, getMassPostSaleJobOrdersWorker);
}
